export const mockTabDetailsTableHeadings = {
  sales: {
    categoryType: "sales",
    items: [
      "Enquiry Number",
      "Company",
      "Document Number",
      "QN Date",
      "Total Amount",
      "Viewed By",
      "Quotation Status",
    ],
  },
};

export const mockTabDetailsTableData = {
  sales: {
    categoryType: "sales",
    items: [
      {
        "Enquiry Number": "EQ100325",
        Company: "Fine Punch",
        "Document Number": "EQ00138",
        "QN Date": "10/10/2012",
        "Total Amount": "Rs. 150000.00",
        "Viewed By": "Sam",
        "Quotation Status": "pending",
      },
      {
        "Enquiry Number": "EQ100329",
        Company: "Fine Punch",
        "Document Number": "EQ00138",
        "QN Date": "10/10/2012",
        "Total Amount": "Rs. 150000.00",
        "Viewed By": "Sam",
        "Quotation Status": "failed",
      },
      {
        "Enquiry Number": "EQ100323",
        Company: "Fine Punch",
        "Document Number": "EQ00138",
        "QN Date": "10/10/2012",
        "Total Amount": "Rs. 150000.00",
        "Viewed By": "Sam",
        "Quotation Status": "complted",
      },
    ],
  },
};
